/* eslint-disable */

import { Button, Checkbox, Grid } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import {
  makeStyles
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { navigate } from "gatsby";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import DataService from "../../services/api/data_services";
import SnackBar from "../../templates/SnackBar";
import "./ContactUsRightGrid.scss";

export const Context = React.createContext({ value: null, setValue: () => {} });

const ContactUsRightGrid = (props) => {
  let formData = {
    firstName: "",
    lastName: "",
    organization: "",
    jobTitle: "",
    email: "",
    phone: "",
    location: "",
    message: "",
    articleId: "",
    // interestedIn: [],
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    margin: {
      width: "100%",
    },
    error: {
      color: "red",
      fontSize: "14px",
      paddingTop: "5px",
    },
  }));

  const classes = useStyles();
  const [value, setValue] = useState(null);

  const [whitePdf, setWhitePdf] = useState("no");
  const [clientPdf, setClientPdf] = useState("no");
  const [hoverImg3, sethoverImg3] = useState(false);
  const [hoverImg4, sethoverImg4] = useState(false);
  const [hoverImg5, sethoverImg5] = useState(false);
  const [showError, setShowError] = useState(false);
  const [contactusForm, setcontactusForm] = useState(formData);
  const [checked, setchecked] = useState([]);
  const [approval, setapproval] = useState(false);
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState();
  const [approvalOpt, setapprovalOpt] = useState(false);
  const updateCount = window.localStorage.setItem("pdf_file", props.pdfFile);
  let history = useHistory();

  const queryString =
    typeof window !== "undefined" ? window.location.href.split("/")[3] : "";

    useEffect(() => {
      DataService.getData(`https://ipapi.co/json/`)
      .then((res) => setcontactusForm({ ...contactusForm, location: res.city }));
    },[]);

  const handleChange = (event, key) => {
    if (key === "firstName") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "lastName") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "organization") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "jobTitle") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "email") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    } else if (key == "phone") {
      let validatedValue = event.target.value.replace(
        /[a-zA-Z`~!@#$%^&*()_|\=?;:'",.<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "location") {
      let validatedValue = event.target.value.replace(
        /[0-9`~!@#$%^&*()_|+\-=?;:<>\{\}\[\]\\\/]/gi,
        ""
      );
      setcontactusForm({ ...contactusForm, [key]: validatedValue });
    } else if (key == "message") {
      let validatedValue = event.target.value.replace(/<>\{\}\[\]\\\/]/gi, "");
      setcontactusForm({ ...contactusForm, [key]: event.target.value });
    }
  };
  const dynamicPageCategory =
    queryString === "white-paper" ? "whitepaper" : "clientstory";

  const handleSubmit = (e) => {
    e.preventDefault();
    // contactusForm.interestedIn = checked;
    contactusForm.privacy_policy = approval;
    contactusForm.opt_in = approvalOpt;
    contactusForm.articleId = props.articleid;
    setchecked([]);
    setcontactusForm(formData);
    // setapproval(false);
    DataService.postData(`admin/api/sendmail`, contactusForm, {
      type: dynamicPageCategory,
    })
      .then((response) => {
        if (response) {
          if (typeof window !== `undefined` && queryString === "white-paper") {
            navigate(`/thank-you-white-paper?title=${props.bannerTitle}`);
            // window.location.href = `/thank-you-white-paper?title=${props.bannerTitle}`;
          } else {
            navigate(`/thank-you-client-story?title=${props.bannerTitle}`);
            // window.location.href = `/thank-you-client-story?title=${props.bannerTitle}`;
          }
        }
      })
      .catch((error) => {
        setSnackbarStatus(true);
        setSnackbarMessage(error.message);
      });
  };
  const validateSubmit = (e) => {
    if (approval === true) {
      setShowError(false);
      handleSubmit(e);
    } else {
      setShowError(true);
    }
  };
  return (
    <React.Fragment>
      <SnackBar
        isOpen={snackbarStatus}
        message={snackbarMessage}
        close={() => setSnackbarStatus(false)}
      />
      {/* <Grid className="contactus-subtitle" container direction="column"> */}
      {/* <Grid item xs={12} sm={4} md={12}> */}
      <div className="full-story-title">
        <span className="black-line3letter">See</span> the full story!
      </div>
      <div className="mt-30 dynamic-story-sub">
        Fill out the form below to receive a<br /> copy of the full story
      </div>
      {/* </Grid>
        <Grid item xs={12} sm={4} md={12}>
        Fill out and send a form.<br/> We will revert you with the full story
        </Grid>
        <Grid className="mt-50" item xs={12} sm={4} md={6}>
          <b>I'm interested in...</b>
        </Grid>
      </Grid> */}
      <Grid className="mt-20" container direction="column">
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="first_name"
              className="floating__input"
              name="first_name"
              type="text"
              placeholder="First Name *"
              onChange={(event) => handleChange(event, "firstName")}
              value={contactusForm.firstName}
            />
            <label
              htmlFor="first_name"
              className="floating__label"
              data-content="First Name *"
            >
              <span className="hidden--visually">First Name</span>
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="last_name"
              className="floating__input"
              name="last_name"
              type="text"
              placeholder="Last Name"
              onChange={(event) => handleChange(event, "lastName")}
              value={contactusForm.lastName}
            />
            <label
              htmlFor="last_name"
              className="floating__label"
              data-content="Last Name"
            >
              <span className="hidden--visually">Last Name</span>
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="Organization"
              className="floating__input"
              name="Organization"
              type="text"
              placeholder="Organization *"
              onChange={(event) => handleChange(event, "organization")}
              value={contactusForm.organization}
            />
            <label
              htmlFor="Organization"
              className="floating__label"
              data-content="Organization *"
            >
              <span className="hidden--visually">Organization</span>
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="job_title"
              className="floating__input"
              name="job_title"
              type="text"
              placeholder="Job Title"
              onChange={(event) => handleChange(event, "jobTitle")}
              value={contactusForm.jobTitle}
            />
            <label
              htmlFor="job_title"
              className="floating__label"
              data-content="Job Title"
            >
              <span className="hidden--visually">Job Title</span>
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="email"
              className="floating__input"
              name="email"
              type="email"
              placeholder="Email *"
              onChange={(event) => handleChange(event, "email")}
              value={contactusForm.email}
            />
            <label
              htmlFor="email"
              className="floating__label"
              data-content="Email *"
            >
              <span className="hidden--visually">Email</span>
            </label>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="phone"
              className="floating__input"
              name="phone"
              type="tel"
              placeholder="Phone *"
              onChange={(event) => handleChange(event, "phone")}
              value={contactusForm.phone}
            />
            <label
              htmlFor="phone"
              className="floating__label"
              data-content="Phone *"
            >
              <span className="hidden--visually">Phone</span>
            </label>
          </div>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <div className="floating-dynamic">
            <input
              id="location"
              className="floating__input"
              name="location"
              type="text"
              placeholder="Phone *"
              onChange={(event) => handleChange(event, "location")}
              value={contactusForm.location}
            />
            <label
              htmlFor="location"
              className="floating__label"
              data-content="Location"
            >
              <span className="hidden--visually">Location</span>
            </label>
          </div>
        </Grid> */}
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            label= {props.type ==="white-paper" ? "Comments": "How can we help?"}
            multiline
            rows={3}
            variant="filled"
            id="description"
            name="description"
            onChange={(event) => handleChange(event, "message")}
            value={contactusForm.message}
            InputLabelProps={{
              style: { color: "#0000008a", fontSize: "18px" },
            }}
            InputProps={{
              disableUnderline: true,
              fullWidth: true,
              style: {
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "5px",
              },
            }}
            style={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <div className="contact-mb">
            <div
              role="presentation"
              onChange={() => {
                setapproval(!approval);
                setShowError(false);
                handleChange(!approval, "privacy_policy");
              }}
            >
              <Checkbox
                color="primary"
                checked={approval}
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            </div>
            <div className="approval-text">
              <i>
                I agree to share my information with you and understand it will
                be used as described in{" "}
                <a className="atagclass" target="_blank" href="/privacy-policy">
                  Digiryte's privacy policy.
                </a>
              </i>
              {showError === true && (
                <FormHelperText className={classes.error}>
                  *This permission is required before we collect your
                  information
                </FormHelperText>
              )}
            </div>
          </div>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <div className="contact-mb">
            <div
              role="presentation"
              onChange={() => {
                setapprovalOpt(!approvalOpt);
                handleChange(!approvalOpt, "opt_in");
              }}
            >
              <Checkbox
                color="primary"
                style={{ padding: "1px", paddingLeft: "10px" }}
                checked={approvalOpt}
                inputProps={{ "aria-label": "secondary checkbox" }}
              />
            </div>
            <i className="approval-text">Opt-in for our featured content!!!</i>
          </div>
        </Grid> */}
        <Grid item xs={12} sm={12} md={12}>
          <div
            style={{ marginTop: "20px" }}
            role="presentation"
            onClick={(e) => {
              contactusForm.firstName &&
                contactusForm.organization &&
                contactusForm.email &&
                contactusForm.phone &&
                validateSubmit(e);
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              style={{ margin: "9px" }}
              disabled={
                !(
                  contactusForm.firstName &&
                  contactusForm.organization &&
                  contactusForm.email &&
                  contactusForm.phone
                )
              }
              // routepath="/thank-you-contact"
            >
              SUBMIT
            </Button>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ContactUsRightGrid;
